import React from "react";

export const UiGrayListCard = (props) => {
  return (
    <>
      <div className="df-gray-list-card mb-1">
        <div className={props.className}>{props.children}</div>
      </div>
    </>
  );
};
